import { render, staticRenderFns } from "./BlocklistDialog.vue?vue&type=template&id=7a35cf00"
import script from "./BlocklistDialog.vue?vue&type=script&lang=js"
export * from "./BlocklistDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports